export const accounts = {
    layout: {
        listTitle: 'Contas',
        archivedTitle: 'Contas arquivadas',
        newAccountTitle: 'Nova Conta',
        editAccountTitle: 'Editar Conta',
        reportTitle: 'Relatório da conta',
    },
    types: {
        checking: 'Conta Corrente',
        savings: 'Poupança',
        wallet: 'Carteira',
        digital: 'Conta Digital',
        investment: 'Investimento',
        other: 'Outro',
    },
    list: {
        transferAction: 'Transferir',
        transferActionAccessibility: 'Transferir de {{name}}',
        archiveAction: 'Arquivar',
        archiveActionAccessibility: 'Arquivar {{name}}',
        archivedRowLabel: 'Contas arquivadas',
        archivedRowAccessibility_one: '1 conta arquivada. Abrir lista',
        archivedRowAccessibility_other: '{{count}} contas arquivadas. Abrir lista',
        excludedBadge: 'Fora do total',
        reservedLabel: 'Reservado',
        submersaWarning: 'Caixinhas acima do saldo — lance a entrada que falta ou resgate de uma caixinha',
        availableBalanceLabel: 'Saldo disponível',
        totalBalanceLabel: 'Saldo total',
        deltaThisMonth: '{{amount}} este mês',
        accountCount_one: '{{count}} conta',
        accountCount_other: '{{count}} contas',
        emptyTitle: 'Nenhuma conta',
        emptySubtitleWithArchived: 'Suas contas arquivadas estão logo abaixo, em Contas arquivadas.',
        emptySubtitle: 'Adicione sua primeira conta para começar',
        emptyAction: 'Adicionar conta',
    },
    archived: {
        reactivateButton: 'Reativar',
        emptyTitle: 'Nenhuma conta arquivada',
        emptySubtitle: 'Contas arquivadas aparecem aqui para você reativar quando quiser.',
    },
    form: {
        typeChecking: 'Corrente',
        typeSavings: 'Poupança',
        typeWallet: 'Carteira',
        typeDigital: 'Digital',
        typeInvestment: 'Investimento',
        typeOther: 'Outro',
        nameLabel: 'Nome da conta',
        namePlaceholder: 'Ex: Nubank, Carteira',
        typeSectionLabel: 'Tipo de conta',
        institutionLabel: 'Instituição / Banco',
        institutionPlaceholder: 'Nome da instituição (opcional)',
        colorLabel: 'Cor',
        initialBalanceLabel: 'Saldo inicial',
        excludeFromTotalsLabel: 'Fora do saldo total',
        excludeFromTotalsDescription: 'Mantém a conta visível e disponível para transferências, mas exclui esse saldo dos totais, patrimônio e projeções.',
        unarchiveAction: 'Desarquivar conta',
        archiveAction: 'Arquivar conta',
        archiveDescription: 'Some da lista e da Home. O histórico e as transferências ficam guardados.',
        deleteAction: 'Excluir conta',
        createAccessibility: 'Criar conta',
        saveAccessibility: 'Salvar',
        colorSheetTitle: 'Escolha uma cor',
    },
    archiveDialog: {
        unarchiveTitle: 'Desarquivar conta',
        unarchiveMessage: 'A conta voltará a aparecer nas listagens e cálculos.',
        unarchiveConfirm: 'Desarquivar',
    },
    // Arquivar conta fácil (ADR 0192): toast com Desfazer, confirmação de saldo e bloqueio por caixinha.
    archiveToast: {
        title: 'Conta arquivada',
        message: '{{name}} fica em Contas arquivadas.',
        undo: 'Desfazer',
    },
    archiveBalanceDialog: {
        title: 'Arquivar {{name}}?',
        message: 'Ainda tem {{amount}} nesta conta. Arquivada, ela sai do saldo total e da Home. O histórico fica guardado e você reativa quando quiser.',
        confirm: 'Arquivar',
    },
    archiveBlockedDialog: {
        title_one: 'Esta conta tem uma caixinha',
        title_other: 'Esta conta tem {{count}} caixinhas',
        message_one: 'Para arquivar a conta, resgate o dinheiro ou arquive a caixinha antes. Assim nada fica parado numa conta escondida.',
        message_other: 'Para arquivar a conta, resgate o dinheiro ou arquive as caixinhas antes. Assim nada fica parado numa conta escondida.',
        viewPockets_one: 'Ver caixinha',
        viewPockets_other: 'Ver caixinhas',
        cancel: 'Agora não',
    },
    deleteDialog: {
        title: 'Excluir conta',
        message: 'Tem certeza? Todas as transações desta conta serão mantidas, mas a conta será removida.',
        confirm: 'Excluir',
    },
    detail: {
        typeChecking: 'Conta corrente',
        typeDigital: 'Conta digital',
        typeFallback: 'Conta',
        available: 'Disponível',
        balance: 'Saldo',
        adjustBalanceAction: 'Ajustar saldo',
        pocketAction: 'Caixinha',
        reportAction: 'Relatório',
        emptyTransactionsTitle: 'Nenhuma transação',
        emptyTransactionsSubtitle: 'Não há movimentações em {{month}}',
        searchPlaceholder: 'Buscar neste extrato...',
        emptySearchTitle: 'Nenhum resultado',
        emptySearchSubtitle: 'Nada com esse nome ou valor em {{month}}',
        registerTransferButton: 'Registrar transferência',
        adjustButton: 'Ajustar',
        continueButton: 'Continuar',
        adjustBackAccessibility: 'Voltar para o valor',
        adjustDateAccessibility: 'Data do ajuste',
        adjustReasonPlaceholder: 'Motivo (opcional) — ex.: quebra de caixa',
        newAvailableBalanceLabel: 'Saldo disponível (novo)',
        newRealBalanceLabel: 'Saldo real (novo)',
        // Ponto de partida do ajuste, numa linha só (etapa 1).
        adjustToday: 'Hoje: {{current}}',
        adjustTodayWithReserved: 'Hoje: {{current}} · Caixinhas: {{reserved}} (intactas)',
        differenceOfLabel: 'Diferença de {{amount}}',
        // Etapa 2: a pergunta que decide o que a diferença vira.
        adjustWhereToTitle: 'Pra onde foram {{amount}}?',
        adjustWhereFromTitle: 'De onde vieram {{amount}}?',
        wasTransferLabel: 'Foi transferência',
        transferFromDescription: 'O valor veio de outra conta sua',
        transferToDescription: 'O valor foi para outra conta sua',
        sourceAccountPlaceholder: 'Conta de origem...',
        destinationAccountPlaceholder: 'Conta de destino...',
        // Lançamento real (ADR 0074): a diferença vira despesa/receita em vez de Ajuste de
        // saldo neutro — é o único caminho em que ela entra nos relatórios.
        natureExpenseTitle: 'Lançar como despesa',
        natureIncomeTitle: 'Lançar como receita',
        natureExpenseDescription: 'Gasto não lançado — conta nos relatórios',
        natureIncomeDescription: 'Entrada não lançada — conta nos relatórios',
        natureNeutralTitle: 'Apenas ajustar',
        natureNeutralDescription: 'Corrige o saldo sem entrar nos relatórios',
        adjustCategoryPlaceholder: 'Categoria (opcional)...',
        postExpenseButton: 'Lançar despesa e ajustar',
        postIncomeButton: 'Lançar receita e ajustar',
        adjustOnlyButton: 'Ajustar saldo',
        // Descrição do lançamento quando o usuário não escreve motivo.
        adjustmentExpenseDescription: 'Despesa de ajuste',
        adjustmentIncomeDescription: 'Receita de ajuste',
        pocketsTitle: 'Caixinhas',
        cxSheetReservedSuffix: ' · {{amount}} reservado',
        newPocketAccessibility: 'Nova caixinha',
        pocketsEmpty: 'Nenhuma caixinha nesta conta ainda. Toque no + para criar a primeira.',
        pocketProgress: '{{percent}}% de {{amount}}',
        pocketNoGoal: 'sem meta',
        adjustmentTitle: 'Ajuste de saldo',
        changeValueAction: 'Alterar valor',
        deleteAdjustmentTitle: 'Excluir ajuste de saldo?',
        deleteAdjustmentMessage: 'O saldo da conta volta ao que era antes desta correção. Receitas e despesas do mês não mudam.',
        editAccountAccessibility: 'Editar conta',
        newTransactionAccessibility: 'Nova transação nesta conta',
        sortAscendingAccessibility: 'Mais antigos primeiro. Toque para inverter.',
        sortDescendingAccessibility: 'Mais recentes primeiro. Toque para inverter.',
    },
    report: {
        incomeLabel: 'Entradas',
        expenseLabel: 'Saídas',
        netLabel: 'Saldo do período',
        reservas: {
            title: 'Caixinhas',
            deposited: 'Guardado',
            withdrawn: 'Resgatado',
            yielded: 'Rendimento',
            reservedAtEnd: 'Reservado no fim do mês',
            info: 'Guardar e resgatar não são Entrada nem Saída: o dinheiro continua na conta e só muda o Disponível. O rendimento também aparece nas Entradas.',
        },
        itemsLabel: 'Itens',
        itemCount_one: '{{count}} lançamento',
        itemCount_other: '{{count}} lançamentos',
        adjustmentsLabel: 'Ajuste de saldo',
        // O ajuste corrige o saldo, não é entrada nem saída (mesma regra do extrato). Fica
        // na lista e fora dos totais — a nota existe para que a diferença não pareça erro.
        adjustmentsNote_one: '{{count}} ajuste de saldo no período — aparece na lista, mas não entra em entradas e saídas.',
        adjustmentsNote_other: '{{count}} ajustes de saldo no período — aparecem na lista, mas não entram em entradas e saídas.',
        byCategoryTitle: 'Por categoria',
        byTagTitle: 'Por tag',
        // Movimento sem categoria por natureza — cada um em linha própria, para o balde
        // "Sem categoria" continuar significando só "esqueci de categorizar".
        transfersLabel: 'Transferências',
        invoicesLabel: 'Faturas de cartão',
        loansLabel: 'Valores a receber',
        uncategorized: 'Sem categoria',
        untagged: 'Sem tag',
        // Rótulo de LINHA de filtro (FilterRow) — curto, pra sobrar largura ao valor.
        filterByCategory: 'Categorias',
        allCategories: 'Todas as categorias',
        filterByTag: 'Tags',
        allTags: 'Todas as tags',
        filterCategoryMulti: '{{n}} categorias',
        filterTagMulti: '{{n}} tags',
        emptyFilter: 'Nenhum lançamento com esse filtro.',
        emptyMonth: 'Nenhuma movimentação em {{month}}.',
        exportPdf: 'Exportar PDF',
        exportError: 'Erro ao exportar',
        pdfTitle: 'Conta {{name}}',
        pdfSectionTitle: 'Lançamentos',
        pdfColDate: 'Data',
        pdfColDescription: 'Descrição',
        pdfColCategory: 'Categoria',
        pdfColTag: 'Tag',
        pdfColItems: 'Itens',
        pdfColIncome: 'Entradas',
        pdfColExpense: 'Saídas',
        pdfColAmount: 'Valor',
    },
};
